import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useUserStore = create(
    persist(
        (set) => ({
            user: null,
            companies: [],
            setUser: (user) => set({ user }),
            setCompanies: (companies) => set({ companies }),
            addCompany: (companyId) =>
                set((state) => ({ companies: [...state.companies, companyId] })),
            removeCompany: (companyId) =>
                set((state) => ({
                    companies: state.companies.filter((id) => id !== companyId),
                })),
            clearCompanies: () =>
                set((state) => ({
                    companies: []
                })),
            clearUser: () => set({ user: null, companies: [] }),
        }),
        {
            name: 'useUserStore',
        }
    )
);

export default useUserStore;